// Project data. All wording (subtitle, role, status, description) lives in i18n under `projects.data.<key>`.

const range = (from, to, path) => {
    const out = [];
    for (let i = from; i <= to; i++) out.push(path(i));
    return out;
};

const smartPM = range(0, 14, i => require(`./images/SmartPM/${i}.webp`));
const focojem = range(1, 4, i => require(`./images/focojem/${i}.webp`));
const focojemDesktop = range(1, 7, i => require(`./images/focojem/desktop/${i}.webp`));
const deliziami = range(1, 3, i => require(`./images/deliziami/${i}.webp`));
const quizziniEdu = range(1, 17, i => require(`./images/Quizzini/Education_Version/${i}.webp`));
const quizziniPro = range(9, 12, i => require(`./images/Quizzini/professional_version/${i}.webp`));
const voltspot = range(0, 2, i => require(`./images/VoltSpot/${i}.webp`));
const issatso = [
    require('./images/issatso/preview2.webp'),
    require('./images/issatso/preview1.webp'),
    ...range(1, 13, i => require(`./images/issatso/${i}.webp`)),
];
const autoBidx = range(1, 2, i => require(`./images/AutoBidx/preview_${i}.webp`));
const altoura = [require('./images/Altoura/1.webp'), require('./images/Altoura/0.webp')];

// Accent colours (r, g, b) used for the card thumbnail gradient and category chip
const BLUE = '37, 99, 235';
const GREEN = '22, 163, 74';
const PURPLE = '124, 58, 237';
const ORANGE = '234, 88, 12';
const INDIGO = '79, 70, 229';
const TEAL = '13, 148, 136';

// Categories shown on cards / used by the filters, in display order
export const CATEGORIES = ['AI', 'Mobile', 'Web', 'Backend', 'Desktop'];

const projects = [
    {
        key: 'smartpm',
        title: 'SmartPM',
        images: smartPM,
        accent: BLUE,
        startDate: '2026-02-01',
        endDate: '2026-06-30',
        status: 'Completed',
        categories: ['AI', 'Web', 'Backend'],
        technologies: {
            personal: ['Spring Boot', 'Angular', 'AWS', 'FastAPI', 'PostgreSQL', 'pgvector', 'Redis', 'Kafka',
                'AWS ECS Fargate', 'Docker', 'GPT-4o', 'XGBoost', 'Isolation Forest', 'SHAP', 'RAG', 'WebSocket'],
            contributors: [],
        },
        link: '',
    },
    {
        key: 'idempotency_starter',
        title: 'Idempotency Spring Boot Starter',
        images: [],
        // No screenshots for a library: the card shows its real usage snippet instead
        snippet: [
            [['annotation', '@Idempotent']],
            [['annotation', '@PostMapping'], ['plain', '('], ['string', '"/orders"'], ['plain', ')']],
            [['keyword', 'public '], ['type', 'ResponseEntity'], ['plain', '<'], ['type', 'Order'], ['plain', '> placeOrder(…) {']],
            [['plain', '    '], ['keyword', 'return '], ['plain', 'ok(orders.charge(request));']],
            [['plain', '}']],
            [],
            [['comment', '// Same Idempotency-Key → original response replayed']],
        ],
        accent: TEAL,
        startDate: '2026-08-02',
        endDate: '2026-09-12',
        status: 'Completed',
        categories: ['Backend'],
        technologies: {
            personal: ['Java', 'Spring Boot', 'Redis', 'JDBC', 'WebFlux', 'Caffeine', 'Micrometer', 'Gradle'],
            contributors: [],
        },
        link: 'https://github.com/benhendayoussef/idempotency-spring-boot-starter',
    },
    {
        key: 'focojem_mobile',
        title: 'Focojem',
        images: focojem,
        accent: GREEN,
        startDate: '2024-03-20',
        endDate: '2024-12-23',
        status: 'Completed',
        categories: ['Mobile'],
        technologies: {
            personal: ['Java', 'XML'],
            contributors: ['Node.js', 'Express', 'Firebase'],
        },
        link: 'https://play.google.com/store/apps/details?id=com.Focojem.focojem',
    },
    {
        key: 'quizzini_edu',
        title: 'Quizzini',
        images: quizziniEdu,
        accent: PURPLE,
        startDate: '2024-10-07',
        endDate: '2024-12-16',
        status: 'Completed',
        categories: ['Mobile', 'AI'],
        technologies: {
            personal: ['Kotlin', 'Jetpack Compose', 'TensorFlow', 'Python', 'Flask'],
            contributors: ['Spring Boot', 'PostgreSQL'],
        },
        link: 'https://www.linkedin.com/posts/youssef-ben-henda-384116240_quizzini-ai-edtech-activity-7276560289448222720-DG1J',
    },
    {
        key: 'scrum_ai',
        title: 'Scrum AI Planner',
        images: [require('./images/ScrumAiAgent/0.webp')],
        accent: INDIGO,
        startDate: '2026-01-10',
        endDate: 'Present',
        status: 'Completed',
        categories: ['AI', 'Backend'],
        technologies: {
            personal: ['Python', 'LangGraph', 'LLM Integration'],
            contributors: ['StateGraph', 'JWT Authentication', 'MongoDB', 'Flask', 'React', 'PostgreSQL'],
        },
        link: '',
    },
    {
        key: 'altoura',
        title: 'Altoura',
        images: altoura,
        accent: TEAL,
        startDate: '2025-06-01',
        endDate: 'Present',
        status: 'In Progress',
        categories: ['Backend'],
        technologies: {
            personal: ['Spring Boot', 'PostgreSQL', 'Stripe', 'Socket', 'REST APIs'],
            contributors: ['React Native'],
        },
        link: 'https://play.google.com/store/apps/details?id=com.synclick.Altoura',
    },
    {
        key: 'issatso',
        title: 'ISSATSO++',
        images: issatso,
        accent: INDIGO,
        startDate: '2025-02-10',
        endDate: '2025-05-05',
        status: 'Completed',
        categories: ['Mobile'],
        technologies: {
            personal: ['Kotlin', 'Jetpack Compose', 'Firebase', 'Retrofit'],
            contributors: ['Spring Boot', 'PostgreSQL', 'RabbitMQ', 'React'],
        },
        link: '',
    },
    {
        key: 'xpresseats',
        title: 'XpressEats++',
        images: [require('./images/XpresEats/1.webp')],
        accent: ORANGE,
        startDate: '2025-08-01',
        endDate: '2025-08-31',
        status: 'Completed',
        categories: ['Mobile', 'Backend'],
        technologies: {
            personal: ['Flutter', 'Spring Boot', 'Firebase', 'PostgreSQL', 'Floor'],
            contributors: [],
        },
        link: '',
    },
    {
        key: 'autobidx',
        title: 'AutoBidX',
        images: autoBidx,
        accent: BLUE,
        startDate: '2025-02-01',
        endDate: null,
        status: 'Completed',
        categories: ['Mobile'],
        technologies: {
            personal: ['Flutter', 'Dart', 'Spring Boot'],
            contributors: ['WebSocket', 'REST APIs'],
        },
        link: '',
    },
    {
        key: 'quizzini_pro',
        title: 'Quizzini Pro',
        images: quizziniPro,
        accent: PURPLE,
        startDate: '2025-01-20',
        endDate: 'Present',
        status: 'Paused',
        categories: ['Mobile', 'AI'],
        technologies: {
            personal: ['Kotlin', 'Jetpack Compose', 'Python', 'Flask', 'TensorFlow'],
            contributors: ['Spring Boot', 'PostgreSQL'],
        },
        link: '',
    },
    {
        key: 'deliziami',
        title: 'Deliziami POS',
        images: deliziami,
        accent: ORANGE,
        startDate: '2024-09-05',
        endDate: '2024-10-05',
        status: 'Completed',
        categories: ['Desktop'],
        technologies: {
            personal: ['WPF', 'XAML', 'Socket.io'],
            contributors: ['Node.js', 'Express', 'Firebase'],
        },
        link: 'https://www.linkedin.com/posts/youssef-ben-henda-384116240_csharp-wpf-nodejs-activity-7269775457632358402-RFTx',
    },
    {
        key: 'focojem_desktop',
        title: 'Focojem Desktop',
        images: focojemDesktop,
        accent: GREEN,
        startDate: '2024-03-20',
        endDate: '2024-12-23',
        status: 'Completed',
        categories: ['Desktop'],
        technologies: {
            personal: ['WPF', 'XAML', 'Socket.io'],
            contributors: ['Node.js', 'Express', 'Firebase'],
        },
        link: 'https://www.linkedin.com/posts/youssef-ben-henda-384116240_focojem-androiddevelopment-synclick-activity-7288903487059312641-ACAG',
    },
    {
        key: 'react_generator',
        title: 'React Project Generator',
        images: [require('./images/ReactProjectGenerator/1.webp')],
        accent: TEAL,
        startDate: '2025-07-01',
        endDate: '2025-07-31',
        status: 'Completed',
        categories: ['Backend', 'Web', 'AI'],
        technologies: {
            personal: ['Spring Boot', 'Node.js', 'Express', 'PostgreSQL'],
            contributors: ['React'],
        },
        link: '',
    },
    {
        key: 'voltspot',
        title: 'VoltSpot',
        images: voltspot,
        accent: GREEN,
        startDate: '2024-04-16',
        endDate: '2024-04-27',
        status: 'Completed',
        categories: ['Mobile', 'Backend'],
        technologies: {
            personal: ['Java', 'XML', 'Spring Boot', 'PostgreSQL'],
            contributors: [],
        },
        link: '',
    },
    {
        key: 'truecaller',
        title: 'True Caller Clone',
        images: [require('./images/TrueCaller/trueCaller.webp')],
        accent: BLUE,
        startDate: '2025-10-03',
        endDate: 'Present',
        status: 'Completed',
        categories: ['Mobile'],
        technologies: {
            personal: ['Kotlin', 'Jetpack Compose'],
            contributors: [],
        },
        link: '',
    },
];

export default projects;
